import { Controller } from "@hotwired/stimulus";

interface TurnstileAPI {
  render(element: HTMLElement, options: { sitekey: string }): string | undefined;
  reset(widgetId: string): void;
  remove(widgetId: string): void;
}

declare global {
  interface Window {
    turnstile?: TurnstileAPI;
  }
}

export default class extends Controller<HTMLElement> {
  private widgetId?: string;
  private connected = false;
  private script: HTMLScriptElement | null = null;
  private form: HTMLFormElement | null = null;

  connect() {
    this.connected = true;
    this.script = document.querySelector<HTMLScriptElement>("#turnstile-script");
    this.script?.addEventListener("load", this.render);
    this.form = this.element.closest("form");
    this.form?.addEventListener("turbo:submit-end", this.reset);
    document.addEventListener("turbo:before-cache", this.remove);
    this.render();
  }

  disconnect() {
    this.connected = false;
    this.script?.removeEventListener("load", this.render);
    this.form?.removeEventListener("turbo:submit-end", this.reset);
    document.removeEventListener("turbo:before-cache", this.remove);
    this.remove();
  }

  private render = () => {
    // The API may load before or after Stimulus connects, including Turbo visits.
    if (!window.turnstile || !this.connected || !this.element.isConnected || this.widgetId !== undefined) return;
    this.widgetId = window.turnstile.render(this.element, {
      sitekey: this.element.dataset.sitekey!,
    });
  };

  private reset = () => {
    // Tokens are single-use, even when subsequent form validation fails.
    if (this.widgetId !== undefined) window.turnstile?.reset(this.widgetId);
  };

  private remove = () => {
    if (this.widgetId !== undefined) {
      window.turnstile?.remove(this.widgetId);
      this.widgetId = undefined;
    }
  };
}
